import { isEquipment } from './browser'
import { isMiniApplets, isMiNiProgram } from './browser'
import wx from 'weixin-js-sdk'
import { encodeSearchParams, loadScript } from './utils'

export default {
  install(Vue) {
    let inputTimer
    Vue.prototype.trim = str => {
      return !!str ? str.replace(/(^\s*)|(\s*$)/g, "") : str
    },
      // 解决键盘弹起之后空白
      Vue.prototype.inputFocus = () => {
        if (inputTimer) {
          clearTimeout(inputTimer)
        }
      },
      // 解决键盘弹起之后空白
      Vue.prototype.inputBlur = () => {
        if (isEquipment.isIOS) {
          inputTimer = setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          }, 200);
        }
      },
      // 将h5与小程序的交互封装成事件 事件类型 事件参数 e: { type: [web|mini|message], url: url, data: data }  
      // type: 类型 [web->跳转h5|mini->跳转小程序指定的网页|message->向小程序传递事件], url: 跳转的h5链接或者小程序链接, data: 传递的数据
      Vue.prototype.interactMini = (e) => {
        console.log(e)
        let isMiniApp = isMiniApplets()
        if (isMiniApp === 'wechat') {
          Vue.use(wx)
          isMiNiProgram().then(res => {
            if (res) {
              if (e.type === 'mini') {
                wx.miniProgram.navigateTo({
                  url: e.url
                })
              } else if (e.type === 'web') {
                window.location.href = e.url
              } else if (e.type === 'message') {
                wx.miniProgram.postMessage({
                  type: 'message',
                  data,
                })
              }
            } else {
              if (e.type === 'web') {
                window.location.href = e.url
              }
            }
          })
        } else if (isMiniApp === 'alipay') {
          loadScript('https://appx/web-view.min.js').then(_ => {
            if (e.type === 'mini') {
              my.navigateTo({
                url: e.url
              })
            } else if (e.type === 'web') {
              my.postMessage({
                type: 'external',
                path: e.url
              })
            } else if (e.type === 'message') {
              my.postMessage({
                type: 'message',
                data,
              })
            }
          })
        } else {
          if (e.type === 'web') {
            window.location.href = e.url
          }
        }
      },
      // 页面跳转
      Vue.prototype.urlFor = (item) => {
        let isMiniApp = isMiniApplets()
        if (isMiniApp === 'wechat') {
          Vue.use(wx)
          isMiNiProgram().then(res => {
            if (res) {
              // 微信小程序操作
              if (item.jumpType == 3) {
                wx.miniProgram.navigateTo({
                  url: item.wxPath || item.urlPath
                })
              } else {
                if ((item.wxURL || item.urlPath) == 'javascript;') {
                  return
                }
                window.location.href = item.wxURL || item.urlPath
              }
            } else {
              if ((item.wxURL || item.urlPath) == 'javascript;') {
                return
              }
              // 微信网页操作 参数需要传递json对象
              window.location.href = item.wxURL || item.urlPath
            }
          })
        } else if (isMiniApp === 'alipay' || isMiniApp === 'eleme') {
          //阿里小程序操作
          loadScript('https://appx/web-view.min.js').then(_ => {
            let path = item.AliPath || item.aliPath || item.AliURL || item.aliURL || item.urlPath
            if (path == 'javascript;') {
              return
            }
            if (item.jumpType == 3) {
              my.navigateTo({
                url: path
              })
            } else if (path.indexOf('enmonster.com') != -1) {
              window.location.href = item.AliURL || item.aliURL || item.urlPath
            } else {
              my.postMessage({
                type: 'external',
                path
              })
            }
          })
        } else {
          window.location.href = item.AliURL || item.aliURL || item.urlPath
        }
      },
      // 延迟触发回调
      Vue.prototype.defer = (fun, sequence, delay) => {
        const promise = new Promise((resolve, reject) => {
          try { fun && fun() } catch (e) { }
          setTimeout(() => {
            resolve()
          }, delay || 1000)
        })
        promise.finally(_ => {
          sequence && sequence()
        })
      }


  }
}